import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@guildeducationinc/recess';
import { PaymentRequestItemType, PaymentRequestStatus, } from '@src/types';
import { getPaymentRequestItemAdjustments } from '@src/utilities/paymentRequestHelper';
import classNames from 'classnames';
import { useLocale } from 'pe-core-frontend';
import styles from './PaymentRequestStatusTag.module.scss';
var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["FULLY_PAID"] = "FULLY_PAID";
    Status["PARTIALLY_PAID"] = "PARTIALLY_PAID";
    Status["NOT_PAID"] = "NOT_PAID";
})(Status || (Status = {}));
const getColors = (status) => {
    let outline = 'background-color-1';
    const text = 'text-color-1';
    let bg = 'background-color-1-tint-1';
    switch (status) {
        case Status.PENDING:
            outline = 'background-color-3';
            bg = 'background-color-3-lighten-50';
            break;
        case Status.FULLY_PAID:
        case Status.PARTIALLY_PAID:
            outline = 'background-color-4';
            bg = 'background-color-4-lighten-50';
            break;
        default:
            outline = 'background-color-2';
            bg = 'background-color-2-lighten-50';
            break;
    }
    return {
        outline,
        text,
        bg,
    };
};
export const PaymentRequestItemStatusTag = ({ paymentRequestItem, size = 'small', paymentRequest, }) => {
    const { t } = useLocale();
    const amountToPay = Number(paymentRequestItem.amountToPay ?? 0);
    const adjustment = getPaymentRequestItemAdjustments(paymentRequestItem);
    let status = Status.PENDING;
    if (paymentRequestItem.type === PaymentRequestItemType.SCHOLARSHIP) {
        status = Status.NOT_PAID;
    }
    else if (paymentRequestItem.amountToPay !== null &&
        paymentRequestItem.amountToPay !== undefined) {
        if (amountToPay === 0) {
            // Not paid
            status = Status.NOT_PAID;
        }
        else if ((paymentRequestItem.amountRequested || 0) <= (paymentRequestItem.amountApproved || 0) &&
            amountToPay === adjustment.SCHOLARSHIP.result) {
            // Fully paid
            status = Status.FULLY_PAID;
        }
        else {
            // Partially paid
            status = Status.PARTIALLY_PAID;
        }
    }
    if (paymentRequest.status === PaymentRequestStatus.REJECTED ||
        (paymentRequest.status === PaymentRequestStatus.APPROVED && !amountToPay)) {
        status = Status.NOT_PAID;
    }
    const { outline, text, bg } = getColors(status);
    return (_jsx("div", { children: _jsx("div", { className: classNames(styles.tag, size === 'large' && styles.large), style: {
                color: `var(--${text})`,
                backgroundColor: `var(--${bg})`,
                borderColor: `var(--${outline})`,
            }, children: _jsx(Typography, { variant: size === 'large' ? 'body1' : 'label2', weight: '400', className: styles.status, children: t(`itemStatus.${status}`) }) }) }));
};
